import { BaseModel } from "models/BaseModel";
import { ObjectWithAnyValues } from "utils/types";
import { CityFields, CityProps } from "./types";

export class City extends BaseModel {
	[CityFields.ID]: string;
	[CityFields.NAME]: string;
	[CityFields.DESCRIPTION]?: string;
	[CityFields.STATE]?: string;

	constructor(data: CityProps) {
		super(data);

		this[CityFields.ID] = data[CityFields.ID];
		this[CityFields.NAME] = data[CityFields.NAME];
		this[CityFields.DESCRIPTION] = data[CityFields.DESCRIPTION];
		this[CityFields.STATE] = data[CityFields.STATE];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const tenant = new City({
			[CityFields.ID]: response[CityFields.ID],
			[CityFields.NAME]: response[CityFields.NAME],
			[CityFields.DESCRIPTION]: response[CityFields.DESCRIPTION],
			[CityFields.STATE]: response[CityFields.STATE]
		});
		return tenant;
	}
}
